import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKaaba } from '@fortawesome/free-solid-svg-icons';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import { useTranslation } from 'react-i18next';

const NavbarVerticalMenuItem = ({ route }) => {
  const { t } = useTranslation();

  return (
    <Flex alignItems="center">
      {route.icon && (
        <span className="nav-link-icon">
          <FontAwesomeIcon
            icon={route.icon === 'kaaba' ? faKaaba : route.icon}
          />
        </span>
      )}
      <span className="nav-link-text nav-text ps-1">{t(route.name)}</span>
      {route.badge && (
        <SoftBadge pill bg={route.badge.type} className="ms-2">
          {route.badge.text}
        </SoftBadge>
      )}
    </Flex>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired
};

export default React.memo(NavbarVerticalMenuItem);
